// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"Loader_loader_wrapper__QANfL","loader_color":"Loader_loader_color__YHhdP","loader":"Loader_loader__sP23u","spin":"Loader_spin__EilsG"};